// 各ブラウザの親クラス.
import * as React from 'react';
import * as Const from '../../constants/InterestCheck';
import { detect } from 'detect-browser';
import { User, Male, Female } from '../../constants/UserListField';
import { convertInterestCheckVisitDate } from '../../utils/dateUtil';
import { ResponseData, Check, Multiple } from '../../constants/InterestCheck';

// 興味関心チェックシート.
interface TableProps extends React.Props<{}> {
  // 親から渡された.
  moffAPI: any;
  total: number;
}

export class BaseBrowser extends React.Component<TableProps, {}> {
  user: User;
  interestCheck: ResponseData;

  // 全体のシーケンス数.
  total: number;

  // 利用者氏名.
  userName: string;

  // 生年.
  birthYear: string;

  // 性別.
  gender: number;

  // 聞き取り日.
  hearingDate: string;

  /**
   * 更新
   */
  refresh() {
    // 利用者氏名.
    if (this.user) {
      this.userName = this.user.user_name;

      // 生年.
      this.birthYear = this.user.user_birth_year;

      // 性別.
      this.gender = this.user.user_gender;
    }

    if (this.interestCheck) {
      // 聞き取り日.
      const tmpDate = this.interestCheck.visited_day ?
        convertInterestCheckVisitDate(this.interestCheck.visited_day) : '';
      this.hearingDate = tmpDate;
    }
  }

  componentWillMount() {
    // 全体のシーケンス数.
    this.total = this.props.total;
  }

  /**
   * cssの描画
   * @method renderCSS
   * @return {JSX.Element} JSX.
   */
  renderCSS(): JSX.Element {
    // 継承したクラスで実装する.
    return <div />;
  }

  /**
   * 1行表示.
   * @method renderRow
   * @param {String} leftItem 左の項目.
   * @param {String} rightItem 右の項目.
   * @param {Check} leftCheckList 左の項目の丸かどうかリスト.
   * @param {Check} rightCheckList 右の項目の丸かどうかリスト.
   * @return {JSX.Element} JSX.
   */
  renderRow(leftItem: string, rightItem: string, leftCheckList: Check, rightCheckList: Check): JSX.Element {
    return (
      <tr className="oneRow">
        <td className="leftTd">{leftItem}</td>
        <td className="middleTd">{leftCheckList.do ? Const.CIRCLE : ''}</td>
        <td className="middleTd">{leftCheckList.want ? Const.CIRCLE : ''}</td>
        <td className="middleTd">{leftCheckList.interested ? Const.CIRCLE : ''}</td>
        <td className="leftTd">{rightItem}</td>
        <td className="middleTd">{rightCheckList.do ? Const.CIRCLE : ''}</td>
        <td className="middleTd">{rightCheckList.want ? Const.CIRCLE : ''}</td>
        <td className="rightTd">{rightCheckList.interested ? Const.CIRCLE : ''}</td>
      </tr>
    );
  }

  /**
   * 1行表示(改行あり).
   * @method renderRowWithBr
   * @param {String} leftItem 左の項目.
   * @param {String} rightItem1 右の項目改行まで.
   * @param {String} rightItem2 右の項目改行後.
   * @param {Check} leftCheckList 左の項目の丸かどうかリスト.
   * @param {Check} rightCheckList 右の項目の丸かどうかリスト.
   * @return {JSX.Element} JSX.
   */
  renderRowWithBr(leftItem: string, rightItem1: string, rightItem2: string, 
                  leftCheckList: Check, rightCheckList: Check): JSX.Element {
    return (
      <tr className="oneRow">
        <td className="leftTd">{leftItem}</td>
        <td className="middleTd">{leftCheckList.do ? Const.CIRCLE : ''}</td>
        <td className="middleTd">{leftCheckList.want ? Const.CIRCLE : ''}</td>
        <td className="middleTd">{leftCheckList.interested ? Const.CIRCLE : ''}</td>
        {/* フォント小さく */}
        <td className="leftTd smallFont">{rightItem1}<br />{rightItem2}</td>
        <td className="middleTd">{rightCheckList.do ? Const.CIRCLE : ''}</td>
        <td className="middleTd">{rightCheckList.want ? Const.CIRCLE : ''}</td>
        <td className="rightTd">{rightCheckList.interested ? Const.CIRCLE : ''}</td>
      </tr>
    );
  }

  /**
   * 最後の1行表示.
   * @method renderLastRow
   * @param {String} leftItem 左の項目.
   * @param {String} rightItem 右の項目.
   * @param {Check} leftCheckList 左の項目の丸かどうかリスト.
   * @param {Check} rightCheckList 右の項目の丸かどうかリスト.
   * @return {JSX.Element} JSX.
   */
  renderLastRow(leftItem: string, rightItem: string, leftCheckList: Check, rightCheckList: Check): JSX.Element {
    return (
      <tr className="oneRow">
        <td className="bottomLeftTd">{leftItem}</td>
        <td className="bottomMiddleTd">{leftCheckList.do ? Const.CIRCLE : ''}</td>
        <td className="bottomMiddleTd">{leftCheckList.want ? Const.CIRCLE : ''}</td>
        <td className="bottomMiddleTd">{leftCheckList.interested ? Const.CIRCLE : ''}</td>
        <td className="bottomLeftTd">{rightItem}</td>
        <td className="bottomMiddleTd">{rightCheckList.do ? Const.CIRCLE : ''}</td>
        <td className="bottomMiddleTd">{rightCheckList.want ? Const.CIRCLE : ''}</td>
        <td className="bottomRightTd">{rightCheckList.interested ? Const.CIRCLE : ''}</td>
      </tr>
    );
  }

  /**
   * その他の文字列生成.
   * @method createOther
   * @param {Multiple} other その他のMultiple.
   * @param {string} key Multipleのキー.
   * @return {string} 結果的な文字.
   */
  createOther(other: Multiple, key: string): string {
    if (other) {
      const value = other[key];
      if (value) {
        const column = value.column;
        return `${Const.OTHER}(${column})`;
      }
    }

    const browser = detect();
    if (browser) {
      const name: string = browser.name;
      // Edgeだけその他の空を短く.
      if (name === 'edge') {
        return `${Const.OTHER}(　　　　　　)`;
      }
    }

    return `${Const.OTHER}(　　　　　　　　　)`;
  }

  render() {
    if (this.props.moffAPI.result === undefined) {
      return (null);
    }

    this.interestCheck = this.props.moffAPI.result.interestCheck;
    this.user = this.props.moffAPI.result.user;
    this.refresh();

    const defaultVal = {interested: false, do: false, want: false};
    let checkOther1: Check = defaultVal;
    let checkOther2: Check = defaultVal;
    let checkOther3: Check = defaultVal;
    let checkOther4: Check = defaultVal;

    // そもそもadditional_itemが存在しないことも有る.
    if (this.interestCheck.additional_item) {
      if (this.interestCheck.additional_item.other1) {
        checkOther1 = this.interestCheck.additional_item.other1.check;
      }
      if (this.interestCheck.additional_item.other2) {
        checkOther2 = this.interestCheck.additional_item.other2.check;
      }
      if (this.interestCheck.additional_item.other3) {
        checkOther3 = this.interestCheck.additional_item.other3.check;
      }
      if (this.interestCheck.additional_item.other4) {
        checkOther4 = this.interestCheck.additional_item.other4.check;
      }
    }

    return [(
        <br id="blank" key="interest_check_print1" />
      ), (
        <div key="interest_check_print2" className="tableTitle interest_check_table">興味関心チェックシート</div>
      ), (
        <div key="interest_check_print3" className="hearing interest_check_table">聞き取り日：{this.hearingDate}</div>
      ), (
        <table key="interest_check_print4" className="interest_check_table">
          <tbody>
            <tr className="oneRow">
              <td className="nameTd">氏名：{this.userName}</td>
              <td className="birthTd">生年：{this.birthYear}年</td>
              {/* 微妙に右にずらすためにスペースが入っている */}
              {/* TODO: あとで歳を戻すためコメントアウト */}
              {/* <td className="ageTd">　歳</td> */}
              <td className="genderTd">性別：{this.gender === 0 ? Male : Female}</td>
            </tr>
          </tbody>
        </table>
      ), (
        <br key="interest_check_print5" />
      ), (
        <table key="interest_check_print6" className="interest_check_table">
          <tbody>
            <tr className="oneRow">
              <td className="topLeftTd">生活行為</td>
              <td className="topMiddleTd smallFont">している</td>
              <td className="topMiddleTd smallFont">してみたい</td>
              <td className="topMiddleTd smallFont">興味がある</td>
              <td className="topLeftTd">生活行為</td>
              <td className="topMiddleTd smallFont">している</td>
              <td className="topMiddleTd smallFont">してみたい</td>
              <td className="topRightTd smallFont">興味がある</td>
            </tr>
            {this.renderRow(Const.TOILET, Const.LIFELONG_LEARNING,
                            this.interestCheck.toilet, this.interestCheck.lifelong_learning)}
            {this.renderRow(Const.BATHING, Const.READING, this.interestCheck.bathing, this.interestCheck.reading)}
            {this.renderRow(Const.WEARING, Const.HAIKU, this.interestCheck.wearing, this.interestCheck.haiku)}
            {this.renderRow(Const.EATING, Const.SHODO, this.interestCheck.eating, this.interestCheck.shodo)}
            {this.renderRow(Const.BRUSHING, Const.PAINTING, this.interestCheck.brushing, this.interestCheck.painting)}
            {this.renderRow(Const.GROOMING, Const.TYPING, this.interestCheck.grooming, this.interestCheck.typing)}
            {this.renderRow(Const.SLEEPING, Const.PHOTO, this.interestCheck.sleeping, this.interestCheck.photo)}
            {this.renderRow(Const.CLEANING, Const.THEATER, this.interestCheck.cleaning, this.interestCheck.theater)}
            {this.renderRow(Const.COOKING, Const.SADO_KADO, this.interestCheck.cooking, this.interestCheck.sado_kado)}
            {this.renderRow(Const.SHOPPING, Const.SINGING, this.interestCheck.shopping, this.interestCheck.singing)}
            {this.renderRow(Const.GARDENING, Const.MUSIC, this.interestCheck.gardening, this.interestCheck.music)}
            {this.renderRow(Const.LAUNDERING, Const.GAMING, this.interestCheck.laundering, this.interestCheck.gaming)}
            {this.renderRow(Const.DRIVING, Const.EXERCISING,
                            this.interestCheck.driving, this.interestCheck.exercising)}
            {this.renderRow(Const.OUTING, Const.STROLLING, this.interestCheck.outing, this.interestCheck.strolling)}
            {this.renderRowWithBr(Const.CHILDREN, Const.PLAYING_SPORTS1, Const.PLAYING_SPORTS2,
                                  this.interestCheck.children, this.interestCheck.playing_sports)}
            {this.renderRow(Const.ANIMAL, Const.DANCING, this.interestCheck.animal, this.interestCheck.dancing)}
            {this.renderRow(Const.FRIENDS, Const.WATCHING_SPORTS,
                            this.interestCheck.friends, this.interestCheck.watching_sports)}
            {this.renderRow(Const.FAMILY, Const.GAMBLING, this.interestCheck.family, this.interestCheck.gambling)}
            {this.renderRow(Const.DATING, Const.KNITTING, this.interestCheck.dating, this.interestCheck.knitting)}
            {this.renderRow(Const.DRINKING, Const.SEWING, this.interestCheck.drinking, this.interestCheck.sewing)}
            {this.renderRow(Const.VOLUNTEER, Const.CROPPING, this.interestCheck.volunteer, this.interestCheck.cropping)}
            {this.renderRow(Const.COMMUNITY_ACTIVITY, Const.EARNING,
                            this.interestCheck.community_activity, this.interestCheck.earning)}
            {this.renderRow(Const.RELIGION, Const.TRAVELING, this.interestCheck.religion, this.interestCheck.traveling)}
            {this.renderRow(
              this.createOther(this.interestCheck.additional_item, 'other1'),
              this.createOther(this.interestCheck.additional_item, 'other3'),
              checkOther1, checkOther3)}
            {this.renderLastRow(
              this.createOther(this.interestCheck.additional_item, 'other2'),
              this.createOther(this.interestCheck.additional_item, 'other4'),
              checkOther2, checkOther4)}
          </tbody>
        </table>
    ), (
      this.renderCSS()
    )];
  }
}



// WEBPACK FOOTER //
// ./src/components/InterestCheckPrintBrowsers/BaseBrowser.tsx